import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SobreNos from "./sections/SobreNos";
import TheThreePartners from "./sections/TheThreePartners";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Hero />
      <SobreNos />
      <TheThreePartners />
      <Footer />
    </div>;
}